import React from "react"
import PropTypes from "prop-types"

export default function TableHeader({ setColumnOrder, columnOrder }) {
  return (
    <>
      <tr className="table-head">
        <th className="text-center" style={{ minWidth: "90px" }}>
          Fecha
          <ArrowsOrder
            setColumnOrder={setColumnOrder}
            columnOrder={columnOrder}
            column="skey"
          />
        </th>
        <th className="text-center" style={{ minWidth: "150px" }}>
          No Docto
        </th>
        <th className="text-center" style={{ minWidth: "150px" }}>
          Tipo
        </th>
        <th className="text-center" style={{ minWidth: "170px" }}>
          Banco
        </th>
        <th className="text-center" style={{ minWidth: "170px" }}>
          Nombre Cliente/Proveedor/Gasto
        </th>
        <th className="text-center" style={{ minWidth: "170px" }}>
          Descripción gasto
        </th>
        <th className="text-center" style={{ minWidth: "170px" }}>
          Descripción banco
        </th>
        <th className="text-center" style={{ minWidth: "170px" }}>
          Depósitos
          <ArrowsOrder
            setColumnOrder={setColumnOrder}
            columnOrder={columnOrder}
            column="deposit"
          />
        </th>
        <th className="text-center" style={{ minWidth: "170px" }}>
          Retiros
          <ArrowsOrder
            setColumnOrder={setColumnOrder}
            columnOrder={columnOrder}
            column="payment"
          />
        </th>
        <th className="text-center" style={{ minWidth: "170px" }}>
          Saldo
        </th>
      </tr>
    </>
  )
}

TableHeader.propTypes = {
  setColumnOrder: PropTypes.func,
  columnOrder: PropTypes.object,
}

const ArrowsOrder = ({ setColumnOrder, column, columnOrder }) => {
  const isArrowDownActive =
    columnOrder.column === column && columnOrder.order === "desc"
  const isArrowUpActive =
    columnOrder.column === column && columnOrder.order === "asc"

  return (
    <span className="order arrows-order">
      <span
        onClick={() =>
          setColumnOrder({
            column,
            order: "desc",
          })
        }
        className={`dropdown arrows-order__asc ${
          isArrowDownActive && "active"
        }`}
      >
        <span className="caret"></span>
      </span>
      <span
        onClick={() =>
          setColumnOrder({
            column,
            order: "asc",
          })
        }
        className={`dropup arrows-order__desc ${isArrowUpActive && "active"}`}
      >
        <span className="caret"></span>
      </span>
    </span>
  )
}

ArrowsOrder.propTypes = {
  column: PropTypes.string,
  setColumnOrder: PropTypes.func,
  columnOrder: PropTypes.object,
}
